import RechargeBoard from './variants/rechargeBoard';
import FissionBoard from './variants/fissionBoard';
import DailyBettingBoard from './variants/dailyBettingBoard';
import VsLeaderboard from '@/pages/vs-leaderboard/vs';

export const leaderboardConfig = {
  NEW_USER_RANK_ACTIVITY: {
    label: 'NEW USER RANK',
    component: RechargeBoard,
  },
  FISSION_RANK_ACTIVITY: {
    label: 'FISSION RANK',
    component: FissionBoard,
  },
  OLD_USER_RANK_ACTIVITY: {
    label: 'Daily Betting Championship',
    component: DailyBettingBoard,
  },
  PK_RANK_ACTIVITY: {
    label: 'VS RANK',
    component: VsLeaderboard,
  },
} as const;

export type LeaderboardType = keyof typeof leaderboardConfig;
export const leaderboardTypeList = Object.keys(
  leaderboardConfig,
) as LeaderboardType[];
